// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "4e286cfec56ac3b78fb86908536178b018fd3a04/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};